/* Hero slideshow — cross-fades between Slide blocks with optional autoplay.
   Progressive enhancement: the first slide is server-rendered as .is-active, so
   if this script never runs the hero still shows slide 1 as a static banner. */
(function () {
  'use strict';

  var reducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(section) {
    if (!section || section.dataset.heroInit === 'true') return;

    var slides = Array.prototype.slice.call(
      section.querySelectorAll('[data-hero-slide]')
    );
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-hero-dot]'));
    section.dataset.heroInit = 'true';

    var current = 0;
    slides.forEach(function (slide, i) {
      if (slide.classList.contains('is-active')) current = i;
    });

    var autoplay = section.dataset.heroAutoplay === 'true' && !reducedMotion;
    var interval = parseInt(section.dataset.heroInterval, 10);
    if (isNaN(interval) || interval < 2000) interval = 6000;
    var timer = null;

    function show(index) {
      var next = (index + slides.length) % slides.length;
      if (next === current) return;

      slides.forEach(function (slide, i) {
        var active = i === next;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      dots.forEach(function (dot, i) {
        var active = i === next;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      current = next;
    }

    function next() {
      show(current + 1);
    }

    function start() {
      if (!autoplay || timer) return;
      timer = window.setInterval(next, interval);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
        stop();
        start();
      });
    });

    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);
    section.addEventListener('focusin', stop);
    section.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    start();
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-hero-slideshow]');
    Array.prototype.forEach.call(sections, initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Shopify theme editor: re-init when the hero section is reloaded. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
